import React, {useContext, useEffect, useRef, useState} from 'react'
import logoutIcon from '../../../assets/logout.svg'
import ReactDom from 'react-dom';
import usuarioIcon from '../../../assets/perfil-usuario.svg'
import './userDisplay.scss'
import trophyIcon from "../../../assets/trophy-icon.svg";
import UserPointsContext from "../../organisms/layout/contexts/user-points.context";

type TUserDisplay = {
	userImage: string,
	userName: string,
	onCloseSession: () => any;
	onStartSession: () => any;
	anchor?: React.ComponentType;
	isLoggedIn: boolean;
}

const BlurBackground = () => {
	const content = (
		<div className="t-user-display-blur"></div>
	);

	const root = document.querySelector('#root');

	return ReactDom.createPortal(content, root as Element);
}

const UserDisplay = ({ anchor: Anchor, ...props }: TUserDisplay) => {
	const {points, getPoints} = useContext(UserPointsContext);
	const [optionsMENU, setOptionsMENU] = useState<{ text: string; icon: string; onClick: () => void; }[]>([]);

	const AnchorAdapter = Anchor || React.Fragment;
	const ref: any = useRef(null);

	const [isOpen, setIsOpen] = useState(false);

	const handleCloseSession = () => {
		props.onCloseSession();
		setIsOpen(false);
	}

	const handleToggle = (open?: boolean) => {
		if (open !== undefined)
			setIsOpen(open)
		else
			setIsOpen(!isOpen);
	}

	const navigateProfile = () => {
		handleToggle()
		window.location.href = "/mentoria-financiera/#/perfil";
	}

	const sessionOptions = [
		{
			text: "Perfil",
			icon: "",
			onClick: navigateProfile
		},
		{
			text: "Puntos" + ( points ? `: ${points}` : ''),
			icon: trophyIcon,
			onClick: () => {}
		},
		{
			text: "Cerrar sesión",
			icon: logoutIcon,
			onClick: handleCloseSession
		},
	]

	useEffect(() => {
		if (window.innerWidth <= 768) {
			const sessionOptions = [
				{
					text: "Perfil",
					icon: "",
					onClick: navigateProfile
				},
				{
					text: `Puntos` + ( points ? `: ${points}` : ''),
					icon: trophyIcon,
					onClick: () => {}
				},
				{
					text: "Cerrar sesión",
					icon: logoutIcon,
					onClick: handleCloseSession
				},
			]
			setOptionsMENU(sessionOptions);
		}else{
			const sessionOptions = [
				{
					text: "Perfil",
					icon: "",
					onClick: navigateProfile
				},
				{
					text: "Cerrar sesión",
					icon: logoutIcon,
					onClick: handleCloseSession
				},
			]
			setOptionsMENU(sessionOptions);
		}
	}, []);

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (ref.current && !ref.current?.contains(event.target)) {
				handleToggle(false);
			}
		}
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	useEffect(() => {
		getPoints();
	});

	return (
		<>
			{isOpen && <BlurBackground />}
			<div className="t-user-display" ref={ref}>
				{props.isLoggedIn ?
					<div className="t-user-display__container" onClick={() => handleToggle()}>
						<img width={32} src={props.userImage} referrerPolicy='no-referrer' />
						<span className="t-user-display__name">
							¡Hola! <span>{props.userName}</span>
						</span>
					</div>
					:
					<>
						<span className="t-user-display__login" onClick={props.onStartSession}>
							Iniciar sesión
						</span>
						<img className="t-user-display__login-img" onClick={props.onStartSession} src={usuarioIcon} alt="Iniciar sesión" />
					</>
				}
				{isOpen &&
					<div className="t-user-display-menu">
						<div
							className="t-user-display-menu__item-name"
						>
							<p>¡Hola! <strong>{props.userName}</strong></p>
						</div>
						<span className="t-user-display-menu__divider"></span>
						{optionsMENU.map((option) => {
							const { text, onClick, icon } = option;
							return (
								<div
									className={`t-user-display-menu__item ${icon ? 't-user-display-menu__item--icon' : ''}`}
									onClick={text !== 'Puntos' ? onClick : undefined}
									key={text}
								>
									<p>{text}</p>
									{icon && <img src={icon} alt={text} />}
								</div>
							)
						})

						}
					</div>
				}
			</div>
		</>
	)
}

export default UserDisplay